import React from 'react'
import { Dropdown } from 'react-bootstrap'
import * as ReactIcons from '@src/lib/react-icons'
import { useAuth } from '@src/hooks/useAuth'
import './style.scss'
import { useNavigate } from 'react-router-dom'

type CustomToggleProps = {
  children?: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CustomToggle = React.forwardRef(
  (props: CustomToggleProps, ref: React.Ref<HTMLButtonElement>) => (
    <button
      ref={ref}
      onClick={e => {
        e.preventDefault()
        props.onClick(e)
      }}
    >
      {props.children}
    </button>
  )
)

const Header: React.FC = () => {
  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleLogoutOnClick = () => {
    logout()
    navigate('/login')
  }
  return (
    <header className='header-wrap'>
      <div className='header'>
        <ul className='action-items'>
          {/* TODO: Notification
          <li className='notification'>
            <button>
              <ReactIcons.HiOutlineBell />
              <span />
            </button>
          </li> */}
          <li className='profile'>
            <Dropdown>
              <Dropdown.Toggle as={CustomToggle}>
                <ReactIcons.MdOutlineAccountCircle />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleLogoutOnClick}>登出</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Header
